import BaseApi from "./BaseApi";

export default class StateAndProvinceApi extends BaseApi {
  static getStates = () => this.get("states");

  static getProvinces = () => this.get("provinces");
}
